
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuarterlyInvoiceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuarterlyInvoice"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quarter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"periodStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"invoiceType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patientsInDrclipCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patientsNotInDrclipCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errorCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"warningCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recipientCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rowsWithErrorsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rowsWithWarningsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rowsBlockedByWarningsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"withoutInvoiceCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveredCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactLookupRunning"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"documentsReady"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthorFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":502}};
    doc.loc.source = {"body":"#import \"./AuthorFragment.graphql\"\n\nfragment QuarterlyInvoiceFragment on QuarterlyInvoice {\n  id\n  year\n  quarter\n  periodStart\n  periodEnd\n  invoiceType\n  status\n  startedAt\n  completedAt\n  createdAt\n  updatedAt\n  patientsInDrclipCount\n  patientsNotInDrclipCount\n  errorCount\n  warningCount\n  recipientCount\n  rowsWithErrorsCount\n  rowsWithWarningsCount\n  rowsBlockedByWarningsCount\n  withoutInvoiceCount\n  deliveredCount\n  contactLookupRunning\n  documentsReady\n  author {\n    ...AuthorFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./AuthorFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["QuarterlyInvoiceFragment"] = oneQuery(doc, "QuarterlyInvoiceFragment");
        
